import SelectPackages, { SelectPackagesMode } from "../../../components/packages/SelectPackages";


const ResellerPackages = ({ selectedPackages = [], availablePackages, setSelectedPackages, setCanSubmit }) => {
	return (
		<div>
			<p>These are the packages that the Reseller will have access to when provisioning new customers or passing on access to their retailers.</p>
			<SelectPackages packageData={availablePackages}
				onChangeInput={(fields) => {
						if ("packages" in fields) {
							setSelectedPackages(fields.packages);
						}
					}
				}
				selectedPackages={selectedPackages}
				title={"Package Details"}
				isValid={setCanSubmit}
				mode={SelectPackagesMode.Reseller} />,
		</div>
	);
};

export default ResellerPackages;